<script lang="ts">
export interface MenuProperties {
  text: string;
  href: string;
  internal?: boolean;
  target?: string;
}
</script>
<script setup lang="ts">
defineProps<{
  title: string;
  menu: MenuProperties[];
}>();
</script>

<template>
  <div>
    <h3 class="text-sm font-semibold text-gray-300 tracking-wider uppercase">
      {{ title }}
    </h3>
    <ul class="mt-4 space-y-4">
      <li
        v-for="item in menu"
        :key="item.text"
        class="mb-2"
      >
        <router-link
          v-if="item.internal"
          :to="item.href"
          class="text-base text-gray-200 hover:text-white"
        >
          {{ item.text }}
        </router-link>
        <a
          v-else
          :href="item.href"
          :target="item.target ?? '_self'"
          class="text-base text-gray-200 hover:text-white"
        >
          {{ item.text }}
        </a>
      </li>
    </ul>
  </div>
</template>
